import React from "react";
import spin from "./../../images/icons/spinning-arrows.gif";
import logo from "./../../images/icons/got.gif";
import Header from "../Header/Header";

const Blogs = () => {
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
        <img
          className="align-item-center mt-5 pt-5"
          src={spin}
          width="50px"
          alt=""
        />
        <h1 className="text-center text-success mt-5 pt-5">Coming Soon</h1>
        <img
          className="align-item-center mt-5 pt-5"
          src={spin}
          width="50px"
          alt=""
        />
      </div>
      <div className="mt-5 pt-3">
        <h6 className="text-center fixed-bottom ">
        Copyright <i class="far fa-copyright"></i> {new Date().getFullYear()}{" "}
          by <span className="text-success">Shahriar</span> All Rights Reserved<img className="ms-1" src={logo} width="40px" alt="" />
        </h6>
      </div>
    </div>
  );
};

export default Blogs;
